import React from 'react'
import { NavLink as Link } from 'react-router-dom'

class HomeComponenteDestaqueModeloCard extends React.Component {
    render() {
        return <>{this.renderServico(this.props.conteudo)}</>
    }

    renderServico(conteudo) {
        if (conteudo) {
            switch (conteudo.tipo) {
                case 'serviço':
                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div className="homeDestaqueCard">
                            <div style={backGroudStyle} className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem"></div>
                            <div className="homeDestaqueCardItens">
                                <p className="homeDestaqueModeloCardTitulo1">{conteudo.tituloSuperior}</p>

                                {conteudo.url && conteudo.url.includes('http') ? (
                                    <a className="homeDestaqueModeloCardTitulo2" href={conteudo.url} target="blank">
                                        {conteudo.tituloMenu}
                                    </a>
                                ) : (
                                    <Link className="homeDestaqueModeloCardTitulo2" to={conteudo.url} title={conteudo.tituloMenu}>
                                        {conteudo.tituloMenu}
                                    </Link>
                                )}
                            </div>
                        </div>
                    )

                case 'atalho':
                    return (
                        <div className="homeDestaqueCard">
                            <div className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem"></div>
                            <div>
                                <p className="homeDestaqueModeloCardTitulo1">{conteudo.tituloSuperior}</p>
                                <a className="homeDestaqueModeloCardTitulo2" href={conteudo.url} target="blank">
                                    {conteudo.tituloMenu}
                                </a>
                            </div>
                        </div>
                    )

                case 'conteudo':
                    let params = {
                        conteudo: conteudo.conteudo,
                        titulo: conteudo.tituloMenu,
                    }

                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div className="homeDestaqueCard">
                            <div style={backGroudStyle} className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem"></div>
                            <div>
                                <p className="homeDestaqueModeloCardTitulo1">{conteudo.tituloSuperior}</p>
                                <p className="homeDestaqueModeloCardTitulo2">{conteudo.tituloMenu}</p>
                                <Link
                                    className="botaoAreaDestaque"
                                    to={'/conteudoGrupo/' + btoa(encodeURIComponent(JSON.stringify(params)))}
                                    title={conteudo.tituloMenu}
                                >
                                    ACESSE
                                </Link>
                            </div>
                        </div>
                    )

                default:
                    return <div className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem">{conteudo.tituloMenu} </div>
            }
        }
    }
}

export default HomeComponenteDestaqueModeloCard
